<template>
 
    <div class="col-12 surface-card">
      <div class="col-12" v-if="!$route.query.Email">
        <Breadcrumb :home="home" :model="items" />
      </div>
      <PdfReport :Report="Report" :LogoUrl="LogoUrl" v-if="Report"> </PdfReport>
    </div>
  
</template>


<script>

  import PdfReport from '../../components/PdfReport.vue';

  export default {
    props: ['LogoUrl'],
    components: {
      PdfReport
    },
    data: () => ({
      Props: null,
      Loading: true,
      home: {
        icon: 'pi pi-home',
        to: '/MyDashboard',
      },
      TopThreeColors: ["#FFA726", "#FF7043", "#5C6BC0"],
      CreatingUser: false,
      IsExporting: false,
      items: [
        { label: 'My Empowerment Subscriptions', to: '/MyEmpowerment' },
        { label: 'PowerTools' },
      ],
      canvas: {
        useCORS: true
      },
      Report: null
    }),
    async created() {
      /* eslint-disable no-debugger, no-console */
      this.$emit("set-nav", this.$route)
      var self = this;

      var currentUser = this.$route.query.Email == null ? self.$store.getters.user.userName : this.$route.query.Email;
      await this.$http.post('/Assessment/GetTieredResult', { AssessmentId: 32, AssessorEmail: currentUser }).then(resp => {
        self.Report = resp.data.completeReport;
      });
    },
    methods: {

    }
  }
</script>